<template>
  <div
    class="relative flex flex-wrap items-center space-x-2"
    data-cy="formula-equation"
  >
    <operation-item
      v-if="level.length"
      operation="parenthesisStart"
      class="cursor-pointer rounded-sm bg-disabled p-1"
      data-cy="parenthesis-start"
    />
    <equation-item
      v-for="(item, itemIndex) in formula"
      :key="JSON.stringify(item) + itemIndex"
      :item="item"
      :level="level.concat(itemIndex)"
      @equation-item:add="prependFormulaItem(itemIndex, $event, level)"
      @equation-item:delete="removeFormulaItem(level, itemIndex)"
    />
    <template v-if="level.length">
      <formula-input-toggle @select="appendFormulaItem($event, level)" />
      <operation-item
        operation="parenthesisEnd"
        class="cursor-pointer rounded-sm bg-disabled p-1"
        data-cy="parenthesis-end"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { useAttributeBuilderStore } from "@/stores/customAttributeBuilder";

import OperationItem from "@/components/customAttributes/OperationItem.vue";
import EquationItem from "@/components/customAttributes/formula/EquationItem.vue";
import FormulaInputToggle from "@/components/customAttributes/formula/FormulaInputToggle.vue";

import type { CustomAttributeFormula } from "@/models/customAttributes/customAttribute";
import type { PropType } from "vue";

defineProps({
  formula: {
    type: Object as PropType<CustomAttributeFormula>,
    required: true,
  },
  level: {
    type: Array as PropType<number[]>,
    required: true,
  },
});

const { appendFormulaItem, prependFormulaItem, removeFormulaItem } =
  useAttributeBuilderStore();
</script>
